import { Message } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import JsonData from './JsonData'
import { JSEncrypt } from 'jsencrypt'
import ProConfig from '@/config/config'

class FuncUtils {
  static readonly messageShowTime: number = 5 * 1000

  // 提示框
  static hitMessageInfo(content: string) {
    Message({
      message: content,
      type: 'info',
      duration: FuncUtils.messageShowTime
    })
  }

  // 提示框
  static hitMessageSuccess(content: string) {
    Message({
      message: content,
      type: 'success',
      duration: FuncUtils.messageShowTime
    })
  }

  // 提示框
  static hitMessageWarning(content: string) {
    Message({
      message: content,
      type: 'warning',
      duration: FuncUtils.messageShowTime
    })
  }
  // 提示框
  static hitMessageError(content: string) {
    Message({
      message: content,
      type: 'error',
      duration: FuncUtils.messageShowTime
    })
  }

  static replaceAll(src: string, old_str: string, new_str: string) {
    while (src.indexOf(old_str) >= 0) {
      src = src.replace(old_str, new_str)
    }
    return src
  }

  static permissionError() {
    console.log(UserModule)
    FuncUtils.hitMessageError('您没有权限进行此操作')
  }

  static isValidate() {
    if (UserModule.token && UserModule.id) {
      // console.log("isValidate is true", UserModule.token, UserModule.id)
      return true
    } else {
      // console.log("isValidate is false", UserModule.token, UserModule.id)
      return false
      // return false
    }
  }

  // obj Date对象或者日期的字符串
  // fmt 格式化样式 如: yyyy-MM-dd HH:mm:ss
  // 优化建议
  static formatDate(obj: Date | string, fmt: string): string {
    // 输入验证
    if (!obj || !fmt) {
      return '';
    }

    // 类型转换
    if (typeof obj === 'string') {
      const parsedDate = new Date(obj);
      if (isNaN(parsedDate.getTime())) {
        console.error('Invalid date string:', obj);
        return '';
      }
      obj = parsedDate;
    }

    // 验证是否为有效日期对象
    if (!(obj instanceof Date) || isNaN(obj.getTime())) {
      console.error('obj is not a valid Date object', obj);
      return '';
    }

    const dateParts: { [key: string]: number } = {
      'M+': obj.getMonth() + 1,
      'd+': obj.getDate(),
      'H+': obj.getHours(),
      'm+': obj.getMinutes(),
      's+': obj.getSeconds()
    };

    // 处理年份
    const yearRegex = /(y+)/;
    const yearMatch = yearRegex.exec(fmt);
    if (yearMatch) {
      const match = yearMatch[1];
      fmt = fmt.replace(
        match,
        (obj.getFullYear() + '').substring(4 - match.length)
      );
    }

    // 预编译正则表达式以提高性能
    const regexCache: { [key: string]: RegExp } = {};

    for (const key in dateParts) {
      if (!regexCache[key]) {
        regexCache[key] = new RegExp('(' + key + ')');
      }

      const matchResult = regexCache[key].exec(fmt);
      if (matchResult) {
        const match = matchResult[1];
        const value = dateParts[key];

        fmt = fmt.replace(
          match,
          match.length === 1
            ? value.toString()
            : value.toString().padStart(match.length, '0')
        );
      }
    }

    return fmt;
  }



  /**
   * 更新列表的参数 (老)
   * @param pageInfo
   * @param obj
   * @param defaultParams
   * @param resultParams
   */
  static updateListSearchParams(
    pageInfo: { page?: number; pageSize?: number },
    obj: any,
    defaultParams: Record<string, any>,
    resultParams: Record<string, any>,
    useDbWhere: boolean = true
  ): Record<string, any> {
    // 参数验证
    if (!defaultParams || typeof defaultParams !== 'object') {
      throw new Error('defaultParams must be a valid object');
    }

    if (!resultParams || typeof resultParams !== 'object') {
      throw new Error('resultParams must be a valid object');
    }

    // 创建安全的副本避免修改原始对象
    const safeDefaultParams = { ...defaultParams };
    const safeResultParams = { ...resultParams };
    const safePageInfo = { ...pageInfo };

    if (obj === false) {
      // 没有任何条件页面加载的时候
      return safeDefaultParams;
    } else if (obj === true) {
      // 不改变现有的搜索条件页面刷新的时候
      safeResultParams.page = safePageInfo.page ?? 1;
      safeResultParams.pageSize = safePageInfo.pageSize ?? 10;

      if (safeDefaultParams.pageNo !== undefined) {
        safeResultParams.pageNo = safeDefaultParams.pageNo;
      }

      return safeResultParams;
    } else {
      // 点击搜索按钮的时候
      const finalParams = safeDefaultParams;

      if (finalParams.pageNo !== undefined) {
        finalParams.pageNo = 1;
      }

      if (useDbWhere) {
        if (!(finalParams.hasOwnProperty('dbWhere'))) {
          finalParams.dbWhere = [];
        }

        if (Array.isArray(obj)) {
          const validItems = obj.filter(item => item.value !== undefined);
          finalParams.dbWhere.push(...validItems);
        }
      } else if (Array.isArray(obj)) {
        obj.forEach(item => {
          if (item.field !== undefined) {
            finalParams[item.field] = item.value;
          }
        });
      }

      // 更新分页信息
      safePageInfo.page = 1;
      finalParams.page = safePageInfo.page;
      finalParams.pageSize = safePageInfo.pageSize ?? 10;

      return finalParams;
    }
  }


  static getFieldSelectList(
    select: any,
    keyVal: string = ':',
    splitStr: string = '---'
  ) {
    if (select) {
      if (select.indexOf(keyVal) > 0) {
        const ret: Array<any> = []
        const content = select
        const temp: Array<string> = content.split(splitStr)
        for (const itemStr of temp) {
          const separatorIndex = itemStr.indexOf(keyVal);
          if (separatorIndex !== -1) {
            const value = itemStr.substring(0, separatorIndex);
            const label = itemStr.substring(separatorIndex + 1);
            ret.push({ value, label });
          }
        }
        return ret
      } else {
        return []
      }
    } else {
      return []
    }
  }

  static getItemFromValue(labelValueList: Array<any>, val: any) {
    if (!Array.isArray(labelValueList)) {
      return false;
    }

    const foundItem = labelValueList.find(item => item.value === val);
    return foundItem || false;
  }

  // 分转元
  static fenToYuan(value: number) {
    return value / 100
  }

  // 分转元
  static yuanToFen(value: number) {
    return value * 100
  }

  // 根据权限获取网格归属列表(只展示当前层级及子集)
  static permissionArea(areaData: any[], cityList: any[], noCountry?: boolean) {
    const belongCode = localStorage.getItem('belongCode')
    let filterList: any[] = []
    if (belongCode) {
      const filterArea = areaData.filter((item: any) => {
        return belongCode === item.value
      })
      // 全国
      if (belongCode === '000000') {
        filterList = noCountry
          ? areaData
          : [{ label: '全国', value: '100000', level: 0 }, ...areaData]
      }
      // 省
      else if (filterArea.length) {
        filterList = filterArea
      }
      // 市
      else {
        const cityCodes = belongCode.split(',')
        if (cityCodes.length) {
          const citys = cityList.filter((item: any) => {
            return cityCodes.includes(item.value)
          })
          filterList = citys
        }
      }
    }
    return filterList
  }

  // 根据权限获取网格归属列表(展示当前层级以子集，和当前曾经归属的上级)
  static permissionAreaLink(areaData: any[], cityList: any[]) {
    const belongCode = localStorage.getItem('belongCode');
    if (!belongCode) {
      return [];
    }

    const filterArea = areaData.filter((item: any) => belongCode === item.value);

    // 全国
    if (belongCode === '000000') {
      return areaData;
    }
    // 省
    else if (filterArea.length) {
      return filterArea;
    }
    // 市
    else {
      const cityCodes = belongCode.split(',');
      if (cityCodes.length > 0) {
        // 使用 find 替代嵌套循环，提高性能和可读性
        const province = areaData.find(item =>
          item.children && Array.isArray(item.children) &&
          item.children.some((child: any) => child.value === cityCodes[0])
        );

        if (province) {
          const citys = cityList.filter((item: any) => cityCodes.includes(item.value));
          // 创建新对象避免修改原始数据
          return [{ ...province, children: citys }];
        }
      }
    }

    return [];
  }


  /**
   * @Descript 根据地市编码返回地市名称
   * @Params code 地市编码
   */
  static getAreaNameByCode(code: string) {
    // 特殊二级地市
    const specialCityCodes = JsonData.getSpecialCityCodes()
    // 判断是否为二级地市
    const isCity = typeof code === 'string' &&
      (code.length >= 2 && code.slice(-2) === '00' || specialCityCodes.includes(code));

    // 全国
    if (code === '000000' || code === '100000') return '全国'
    const isProvince = code.indexOf('0000') !== -1 // 判断是否为省份
    if (isProvince) {
      // 一级省份
      const provinceList = JsonData.getProvinceCity()
      const res = provinceList.filter((item) => item.value === code)
      return res[0]?.label
    } else if (isCity) {
      // 二级地市
      const cityList = JsonData.getCityList()
      const res = cityList.filter((item) => item.value === code)
      return res[0]?.label
    } else {
      // 三级区县
      const countyList = JsonData.getCountyList()
      const res = countyList.filter((item) => item.value === code)
      return res[0]?.label
    }
  }

  /**
   * @Descript 根据状态值返回状态名
   * @Params statusList 状态列表
   * @Params status 状态值
   */
  static getStatusNameByStatus(statusList: any[], status: string | number) {
    const res = statusList.filter((item) => item.value == status)
    return res[0]?.label
  }

  // 获取当前时间日期
  static getNowTime() {
    const myDate = new Date();
    const year = myDate.getFullYear();
    const month = String(myDate.getMonth() + 1).padStart(2, '0');
    const day = String(myDate.getDate()).padStart(2, '0');
    const hours = String(myDate.getHours()).padStart(2, '0');
    const minutes = String(myDate.getMinutes()).padStart(2, '0');
    const seconds = String(myDate.getSeconds()).padStart(2, '0');

    const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const week = weekdays[myDate.getDay()];

    const todayTimeStart = `${year}-${month}-${day} 00:00:00`;
    const todayTimeEnd = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return {
      year,
      month,
      day,
      hours,
      minu: minutes,
      sec: seconds,
      week,
      todayTimeStart,
      todayTimeEnd
    };
  }


  // rsa加密
  static rsaEncode(v: any) {
    // 新建JESencrypt对象
    const encryptor = new JSEncrypt()
    // 设置公钥
    encryptor.setPublicKey(ProConfig.rsaPublicKey())
    // rsa加密
    const rsaData = encryptor.encrypt(v)
    return rsaData
  }
}

export default FuncUtils
